var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconOffer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 6,
    y: 4,
    width: 12,
    height: 16,
    className: "invert-dark"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,2 L18,2 C19.1045695,2 20,2.8954305 20,4 L20,20 C20,21.1045695 19.1045695,22 18,22 L6,22 C4.8954305,22 4,21.1045695 4,20 L4,4 C4,2.8954305 4.8954305,2 6,2 Z M6,4 L6,20 L18,20 L18,4 L6,4 Z",
    fill: "#262626",
    className: "invert-light"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#262626",
    x: 8,
    y: 10,
    width: 2,
    height: 8,
    rx: 1,
    className: "invert-light"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#262626",
    x: 11,
    y: 8,
    width: 2,
    height: 10,
    rx: 1,
    className: "invert-light"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#262626",
    x: 14,
    y: 12,
    width: 2,
    height: 6,
    rx: 1,
    className: "invert-light"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconOffer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-offer.8ab1f9481bd74a077e8aab166102a878.svg";